import { c as _c } from "react/compiler-runtime";
import { HotelSearchWrapperViewPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper/hotel-search-wrapper.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { Modal } from "@website/ui/modal";
import { FC } from "react";
export const HotelSearchWrapper: FC<HotelSearchWrapperViewPropertiesType> = properties => {
  const $ = _c(45);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    reference: scrollReference,
    inView
  } = useIsVisible(t0, true);
  const {
    SummaryElement,
    PanelElement,
    disableSticky,
    searchType,
    isSearchPanelOpen,
    setIsSearchPanelOpen,
    isNewPlP
  } = properties;
  const isSearchSticky = !disableSticky && !inView && !["hotel", "villa"].includes(searchType ?? "");
  const summaryAnimationClassName = isSearchPanelOpen ? "pointer-events-none hidden -translate-y-32 opacity-0" : "translate-y-0 opacity-100";
  const panelAnimationClassName = isSearchPanelOpen ? "translate-y-0 opacity-100" : "-translate-y-32 opacity-0";
  let t1;
  if ($[1] !== isSearchPanelOpen || $[2] !== searchType || $[3] !== setIsSearchPanelOpen) {
    t1 = !["hotel", "villa"].includes(searchType ?? "") && <div className="bg-on-surface-disable fixed left-0 top-[73px] z-10 box-border hidden h-screen w-full opacity-100 transition-all duration-200 ease-in-out lg:block" hidden={!isSearchPanelOpen} onClick={setIsSearchPanelOpen.bind(null, false)} />;
    $[1] = isSearchPanelOpen;
    $[2] = searchType;
    $[3] = setIsSearchPanelOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== scrollReference) {
    t2 = <div aria-hidden={true} className="h-px w-full" ref={scrollReference} />;
    $[5] = scrollReference;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `relative top-0 z-10 w-full transition-shadow duration-200 ease-in-out ${["hotel", "villa"].includes(searchType ?? "") ? "z-[1] h-[48px] lg:h-[40px]" : "lg:h-[72px]"} ${isSearchSticky ? "!fixed right-0 top-0" : ""} ${isSearchSticky && !isNewPlP ? "shadow-4" : ""}`;
  const t4 = `overflow-hidden bg-white transition-all duration-200 ease-in-out lg:absolute lg:top-0 lg:z-40 lg:w-full ${["hotel", "villa"].includes(searchType ?? "") ? "h-[48px] lg:h-[72px]" : "h-[72px]"} ${isSearchPanelOpen && ["city", "category"].includes(searchType ?? "") ? "h-[236px] lg:h-[180px]" : "flex w-full justify-center"} ${isSearchPanelOpen ? "overflow-visible" : ""} ${isSearchPanelOpen && ["hotel", "villa"].includes(searchType ?? "") ? "border-secondary shadow-6 h-[144px] rounded-xl border-2 xl:h-[104px]" : ""} `;
  const t5 = `flex size-full items-center justify-center transition-[transform,opacity] duration-200 ease-in-out ${["hotel", "villa"].includes(searchType ?? "") ? "bg-dim-background" : "bg-white px-4"} ${summaryAnimationClassName}`;
  let t6;
  if ($[7] !== setIsSearchPanelOpen) {
    t6 = setIsSearchPanelOpen.bind(null, true);
    $[7] = setIsSearchPanelOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== SummaryElement || $[10] !== t6) {
    t7 = <div className="w-full cursor-pointer" onClick={t6}>{SummaryElement}</div>;
    $[9] = SummaryElement;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `absolute hidden size-full items-center justify-center transition-[transform,opacity] duration-200 ease-in-out lg:flex ${panelAnimationClassName}`;
  let t10;
  if ($[15] !== PanelElement || $[16] !== isSearchPanelOpen || $[17] !== searchType) {
    t10 = isSearchPanelOpen && <div className={`w-full p-6 xl:mx-auto xl:w-[1224px] ${["hotel", "villa"].includes(searchType ?? "") ? "xl:w-[1104px]" : "xl:w-[1224px]"}`}>{PanelElement}</div>;
    $[15] = PanelElement;
    $[16] = isSearchPanelOpen;
    $[17] = searchType;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t4 || $[24] !== t8) {
    t12 = <div className={t4}>{t8}{t11}</div>;
    $[22] = t11;
    $[23] = t4;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t3) {
    t13 = <div className={t3}>{t12}</div>;
    $[26] = t12;
    $[27] = t3;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = ["hotel", "villa"].includes(searchType ?? "") ? "arrow_forward" : "close";
  const t15 = ["hotel", "villa"].includes(searchType ?? "") ? "block h-[64px]" : "";
  let t16;
  if ($[29] !== setIsSearchPanelOpen) {
    t16 = setIsSearchPanelOpen.bind(null, false);
    $[29] = setIsSearchPanelOpen;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = isSearchPanelOpen || false;
  let t18;
  if ($[31] !== PanelElement || $[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t17) {
    t18 = <div className="lg:hidden"><Modal closeIcon={t14} headerStyle={t15} onClose={t16} open={t17} showCloseButton={true} iconClassName="!mb-3 !mr-0">{PanelElement}</Modal></div>;
    $[31] = PanelElement;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const t19 = isSearchSticky ? "h-[72px]" : "hidden";
  let t20;
  if ($[37] !== t19) {
    t20 = <div className={t19} />;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t1 || $[40] !== t13 || $[41] !== t18 || $[42] !== t2 || $[43] !== t20) {
    t21 = <>{t1}{t2}{t13}{t18}{t20}</>;
    $[39] = t1;
    $[40] = t13;
    $[41] = t18;
    $[42] = t2;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
};